import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, PropType, Ref, watch, nextTick } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { ElInput } from 'element-plus'
import { ElMessage } from 'element-plus'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import useFormRules from '@/hooks/useFormRules'
import InputWithUnit from '@/components/InputWithUnit.vue'

import { applyUserWalletWithhold } from '@/api/operation'
import InfoTooltip from '@/components/InfoTooltip.vue'

export type ShowDialogType = 'create' | 'edit'


import { defineComponent } from 'vue'
import { Currency } from '@/types/types'

const __default__ = defineComponent({
  name: 'UserWalletWithhold',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  userID: {
    type: String,
    required: true,
  },
  operatorID: {
    type: String,
    required: true,
  },
  currency: {
    type: Number,
  },
  principal: {
    type: Number,
    required: true,
  },
  gift: {
    type: Number,
    required: true,
  },
  balance: {
    type: Number,
    required: true,
  }
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { getCurrencySymbol } = useProtocolEnums()
const { t } = useI18n()





const createRawFormData = () => ({})

const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule,createRequiredRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  try {

    // await formCom.value.validate()

    isSubmitting.value = true
    formData.value.userId = props.userID
    await applyUserWalletWithhold(formData.value)

    ElMessage.success(t(`Base.opSuccess`))
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}
watch(
  () => props.modelValue,
  (val) => {
    formData.value = createRawFormData()
    formCom.value?.clearValidate()
  },
  { immediate: true },
)

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(_unref(ElDialog), {
    modelValue: _unref(showDialog),
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
    width: "50%",
    class: "upsert-dialog",
    title: _ctx.$t('Base.withhold'),
    "z-index": 2000
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          disabled: !_ctx.$hasPermission('post'),
          loading: isSubmitting.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
          ]),
          _: 1
        }, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formCom",
        ref: formCom,
        "label-position": "top",
        "require-asterisk-position": "right",
        model: formData.value,
        rules: rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "principalAmount",
                    disable: true
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Order.principal')), 1),
                      _createVNode(InfoTooltip, {
                        content: _ctx.$t('Operation.manualWithholdDesc')
                      }, null, 8, ["content"])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: formData.value.principal,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.principal) = $event)),
                        units: [{ label: _unref(getCurrencySymbol)(props.currency), value: '' }]
                      }, null, 8, ["modelValue", "units"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "giftAmount",
                    disable: true
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("label", null, _toDisplayString(_unref(t)('Order.gift')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(InputWithUnit, {
                        modelValue: formData.value.gift,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.gift) = $event)),
                        units: [{ label: _unref(getCurrencySymbol)(props.currency), value: '' }]
                      }, null, 8, ["modelValue", "units"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: formData.value.force,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.force) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('Operation.forceWithhold')), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})